import { create } from "zustand";
import api from "../api/axios";

const useCompanyStore = create((set) => ({
  companyList: [],
  loading: false,

  fetchCompanies: async () => {
    try {
      set({ loading: true });

      const response = await api.get("/companies");

      set({
        companyList: response.data?.data || [],
        loading: false,
      });
    } catch (error) {
      console.error("Company fetch error:", error);

      set({
        loading: false,
      });
    }
  },
}));

export default useCompanyStore;